import React from 'react';
import CircledBang from '../assets/CircledBang';
var CircledBangImage = function () { return React.createElement(CircledBang, { size: 80, color: "#4D5E73" }); };
export default CircledBangImage;
